import { toast } from "../../utils/toast";
import ChannelCover from "../../assets/channel_images/channel_cover.svg";
import ArrowBack from "../../assets/icons/arrow_back.svg";
import Settings from "../../assets/icons/setting.svg";
import Edit from "../../assets/icons/Edit.svg";
import EditLight from "../../assets/lightIcons/edit_light.svg";
import Stack from "../../assets/icons/stack.svg";
import StackLight from "../../assets/lightIcons/curation_light.svg";
import ChannelLogo from "../../assets/icons/default_channel_logo.svg";
import { createGeneralTopic } from "./../../redux/slices/channelItemsSlice";
import Dots from "../../assets/icons/three_dots.svg";
import DotsLight from "../../assets/lightIcons/faqs_dots_light.svg";
import {
  clearCreateTopic,
  setCreateTopicField,
} from "./../../redux/slices/createTopicSlice";
import {
  setChannelField,
  removeCover,
  saveCover,
  fetchChannel,
  createChannelInvite,
  joinChannel,
  leaveChannel,
} from "../../redux/slices/channelSlice.js";
import {
  setCreateChannelField,
  setCreateChannelItems,
} from "../../redux/slices/createChannelSlice.js";
import { setModalModal } from "../../redux/slices/modalSlice.js";

import ChannelSkeleton from "./../skeleton/channelSkeleton";
import InviteChannelPage from "./InviteChannelPage";
import { domainUrl } from "./../../utils/globals";
import { fetchTopics } from "../../redux/slices/reorderTopicSlice.js";
import TopicsTab from "./Tabs/TopicsTab";
import MembersTab from "./Tabs/MembersTab";
import Compressor from "compressorjs";
import { getAppPrefix } from "./../EmbedChannels/utility/embedHelper";
import Delete from "../../assets/icons/Delete.svg";
import DeleteLight from "../../assets/lightIcons/delete_light.svg";

import {
  React,
  useState,
  useEffect,
  useRef,
  useNavigate,
  useDispatch,
  useSearchParams,
  useSelector,
  useParams,
  useModal,
  useLocation,
  isEmbeddedOrExternal,
} from "../../globals/imports";
import {
  setChannelIdToDelete,
  setChannelNameToDelete,
} from "../../redux/slices/deleteChannelSlice.js";
import { canManageChannel } from "../../utils/roles";

const ChannelPage = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [isEditDropdownOpen, setIsEditDropdownOpen] = useState(null);
  const dropdownEditRef = useRef(null);
  const navigate = useNavigate();
  const { handleOpenModal } = useModal();
  const dispatch = useDispatch();
  const channel = useSelector((state) => state.channel);

  const loading = useSelector((state) => state.channel.loading);
  const channelstatus = useSelector((state) => state.channel.channelstatus);
  const [file, setFile] = useState(null);
  const [isEditCover, setIsEditCover] = useState(null);

  const location = useLocation();
  const params = useParams();
  const { channelId } = params;
  const username = params.username || "";

  const [searchParams] = useSearchParams();
  const inviteCode = searchParams.get("code");
  const myData = useSelector((state) => state.myData);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isSubdomain = useSelector((state) => state.auth.isSubdomain);
  // Embed feature toggles (undefined outside the embed store -> directory shows).
  const features = useSelector((state) => state.embedHome?.features) || {};
  const canViewMembers = features.memberDirectory !== false;
  const [activeTab, setActiveTab] = useState("topics");
  const [inviteCopied, setInviteCopied] = useState(false);

  const tabs = [
    { id: 1, name: "Topics", href: "topics" },
    { id: 2, name: "Members", href: "members" },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownEditRef.current &&
        !dropdownEditRef.current.contains(event.target)
      ) {
        setIsEditDropdownOpen(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get("tab");
    if (tab === "members") {
      setActiveTab(tab);
    } else {
      setActiveTab("topics");
    }
  }, []);

  const handleTabClick = (event, href) => {
    event.preventDefault();
    const scrollY = window.scrollY;
    setActiveTab(href);
    if (href === "topics") {
      window.history.pushState(null, "", window.location.pathname);
    } else {
      window.history.pushState(null, "", `?tab=${href}`);
    }
    window.scrollTo(0, scrollY);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const toggleEditDropdown = (id) => {
    setIsEditDropdownOpen(id);
  };

  useEffect(() => {
    if (channelId) {
      dispatch(fetchChannel(channelId));
      dispatch(fetchTopics(channelId));
    }
  }, [channelId, dispatch]);

  // Honor the post-login join intent: a member who clicked "Join channel" while
  // logged out lands here with ?autojoin=true — finish the join automatically.
  useEffect(() => {
    if (
      searchParams.get("autojoin") === "true" &&
      isLoggedIn &&
      channel?._id === channelId &&
      !channel?.isOwner &&
      !channel?.isMember &&
      channel?.requestStatus !== "request"
    ) {
      handleJoinChannel(channel);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, channel?._id, channel?.isMember, channel?.isOwner]);

  const closeDropdown = (event) => {
    setIsDropdownOpen(false);
  };

  const handleShareChannel = (id) => {
    dispatch(setModalModal({ field: "shareUsername", value: username }));
    handleOpenModal("modalShareChannelOpen", id);
  };
  // Sharing now uses the business's custom invite URL for the channel. Copy it
  // to the clipboard; when no URL is set the share button isn't rendered.
  const handleCopyInvite = () => {
    const url = channel?.inviteUrl;
    if (!url) return;
    navigator.clipboard
      ?.writeText(url)
      .then(() => {
        setInviteCopied(true);
        setTimeout(() => setInviteCopied(false), 1500);
      })
      .catch(() => {});
  };
  const handleOwnerShareChannel = (id) => {
    dispatch(setModalModal({ field: "shareUsername", value: username }));
    dispatch(createChannelInvite(id))
      .unwrap()
      .then((invite) => {
        dispatch(setChannelField({ field: "code", value: invite.code }));
        setTimeout(() => {
          handleOpenModal("modalShareChannelOpen", id);
        }, 500);
      })
      .catch((error) => {
        toast(error, "error");
      });
  };
  const handleCreateTopic = () => {
    if (channel._id) {
      dispatch(createGeneralTopic(channel._id))
        .unwrap()
        .then((topic) => {
          navigate(`c-id/topic/${topic._id}`);
        })
        .catch((error) => {
          toast(error, "error");
        });
    }
  };

  const handleTopicModal = (channelId) => {
    dispatch(clearCreateTopic());
    dispatch(setCreateTopicField({ field: "channel", value: channelId }));
    handleOpenModal("modalTopicOpen");
  };
  const handleReorderTopicModal = (channelId) => {
    handleOpenModal("modalTopicReorderOpen", channelId);
  };

  const handleRemoveCover = () => {
    setFile(null);
    dispatch(removeCover(channel._id));
    dispatch(setChannelField({ field: "cover_image", value: "" }));
    dispatch(setChannelField({ field: "imageSource", value: "" }));
    closeDropdown();
  };
  const handleSaveCover = () => {
    const formDataToSend = new FormData();
    formDataToSend.append("channel", channel._id);
    if (file) {
      formDataToSend.append("file", file);
    }
    dispatch(saveCover(formDataToSend))
      .unwrap()
      .then(() => {
        setIsEditCover(false);
      })
      .catch((error) => {
        toast(error, "error");
      });
  };

  const handleCoverUpload = (event) => {
    closeDropdown();
    const file = event.target.files[0];
    if (file) {
      if (file.size > 20 * 1024 * 1024) {
        toast(
          `The file "${file.name}" exceeds the 20 MB size limit and will not be uploaded.`
        );
        return;
      }
      if (file.size >= 7 * 1024 * 1024) {
        new Compressor(file, {
          quality: 0.6,
          maxWidth: 1920,
          maxHeight: 1080,
          success(result) {
            setFile(result);
            const reader = new FileReader();
            reader.onloadend = () => {
              dispatch(
                setChannelField({ field: "cover_image", value: reader.result })
              );
              dispatch(
                setChannelField({ field: "imageSource", value: "upload" })
              );
            };
            reader.readAsDataURL(result);
          },
          error(err) {
            toast("Image compression failed: " + err);
          },
        });
      } else {
        setFile(file);
        const reader = new FileReader();
        reader.onloadend = () => {
          dispatch(
            setChannelField({ field: "cover_image", value: reader.result })
          );
          dispatch(setChannelField({ field: "imageSource", value: "upload" }));
        };
        reader.readAsDataURL(file);
      }

      setIsEditCover(true);
    }
  };

  const handleEditChannel = () => {
    const transformedData = {
      ...channel,
    };
    dispatch(setCreateChannelItems(transformedData));
    dispatch(setCreateChannelField({ field: "isEdit", value: true }));
    setTimeout(() => {
      handleOpenModal("modalChannelOpen");
    }, 500);
  };
  const handleJoinChannel = (channel) => {
    if (isLoggedIn) {
      if (channel?.isMember) {
        navigate(
          `${getAppPrefix()}/user/${username}/channel/${
            channel._id
          }/c-id/topic/${channel.topics?.[0]?._id}`
        );
      } else if (channel?.requestStatus === "request") {
        return;
      } else {
        dispatch(joinChannel(channel._id))
          .unwrap()
          .then((response) => {
            if (response.joined) {
              if (response.channel?.topics?.length > 0) {
                navigate(
                  `${getAppPrefix()}/user/${username}/channel/${
                    channel._id
                  }/c-id/topic/${response.channel.topics[0]?._id}`
                );
              } else {
                navigate(
                  `${getAppPrefix()}/user/${username}/channel/${channel._id}`
                );
              }
            }
          })
          .catch((error) => {
            toast(error, "error");
          });
      }
    } else {
      if (isSubdomain) {
        window.location.replace(
          `https://${domainUrl}/get-started?redirectDomain=${username}&redirect=/user/${username}/channel/${channel._id}`
        );
      } else {
        // Carry a join intent through login so the member actually joins (and
        // lands inside) the channel they clicked, instead of bouncing back to
        // the channel page still un-joined.
        const target = `${getAppPrefix()}/user/${username}/channel/${channel._id}?autojoin=true`;
        navigate(
          `${getAppPrefix()}/get-started?redirect=${encodeURIComponent(target)}`
        );
      }
    }
  };

  const handleLeaveChannel = () => {
    dispatch(setModalModal({ field: "channelId", value: channel._id }));
    handleOpenModal("modalLeaveChannelOpen");
    // if (isLoggedIn) {
    //   dispatch(leaveChannel(channel._id))
    //     .unwrap()
    //     .then((response) => {
    //       if (response.sucess) {
    //         navigate(`${getAppPrefix()}/user/${myData.username}/profile`);
    //       }
    //     })
    //     .catch((error) => {
    //       toast(error, "error");
    //     });
    // }
  };

  if (loading) {
    return <ChannelSkeleton />;
  }

  if (inviteCode) {
    dispatch(setChannelField({ field: "loading", value: false }));
    return (
      <InviteChannelPage
        code={inviteCode}
        channelId={channelId}
        username={username}
      />
    );
  }

  // Relationship flags come from the backend now (isOwner/isMember/
  // requestStatus); fall back to a correct local compute against the populated
  // user object just in case an older cached payload lacks them.
  const isOwner =
    channel?.isOwner ??
    myData?._id?.toString() ===
      (channel?.user?._id || channel?.user)?.toString();
  // Channel admins get owner-parity for channel management, EXCEPT deletion:
  // admins can delete only when the business has opted in (allowAdminDeleteChannel).
  const canManage = canManageChannel(isOwner, channel?.myRole);
  const canDeleteChannel =
    isOwner ||
    (channel?.myRole === "admin" && channel?.allowAdminDeleteChannel === true);
  const isMember = !!channel?.isMember;
  const isRequested = channel?.requestStatus === "request";
  const firstTopicId = channel?.topics?.[0]?._id;
  const memberCount = channel?.memberCount ?? 0;
  const hasInvite = !!channel?.inviteUrl;

  // console.log(myData);
  // console.log(isOwner);
  // console.log(channel.user);
  return (
    <div className="bg-theme-secondaryBackground w-full h-full flex flex-col overflow-y-auto">
      <div className="relative w-full h-48 shrink-0">
        <img
          src={channel.cover_image ? channel.cover_image : ChannelCover}
          alt="channel-cover"
          onClick={closeDropdown}
          className="w-full h-full object-cover shrink-0"
          loading="lazy"
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = ChannelCover;
          }}
        />
        {/* Scrim: darkens the top so the floating header reads on any cover, and
            eases only a thin band at the very bottom (last ~8%) into the page —
            keeps almost all of the cover visible while avoiding a hard seam. */}
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              "linear-gradient(to bottom, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0) 30%, rgba(0,0,0,0) 92%, var(--theme-secondaryBackground) 100%)",
          }}
        />
        {!isEmbeddedOrExternal() && (
          <div className="sm:hidden absolute left-6 top-3 text-theme-secondaryText">
            <img
              src={ArrowBack}
              alt="arrow-back"
              className="text-theme-secondaryText w-5 h-5 cursor-pointer"
              onClick={() => navigate(-1)}
            />
          </div>
        )}
        {isEditCover && (
          <div
            className="absolute left-3 top-3 cursor-pointer bg-theme-secondaryText px-3 text-sm font-light py-1.5
         text-theme-primaryBackground rounded-lg"
            onClick={handleSaveCover}
          >
            {channelstatus === "loading" ? "Saving" : "Save"}
          </div>
        )}
      </div>
      {isOwner && (
        <div className="absolute right-4 sm:top-2 top-14">
          <img
            src={Settings}
            alt="settings"
            className=" w-6 h-6 cursor-pointer"
            onClick={toggleDropdown}
          />
          {/* <img
            src={SettingsLight}
            alt="settings"
            className="dark:hidden w-6 h-6 cursor-pointer"
            onClick={toggleDropdown}
          /> */}
        </div>
      )}

      {isDropdownOpen && (
        <div
          ref={dropdownRef}
          className="absolute top-8 right-4 mt-2 w-max rounded-md shadow-lg
          bg-theme-dropdown  z-50"
        >
          <div
            className="py-1"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            <div
              className="relative flex flex-row px-4 items-center"
              // onClick={handleOpenCover}
            >
              <img src={Edit} alt="edit" className="dark:block hidden " />
              <img src={EditLight} alt="edit" className="dark:hidden" />
              <p
                className="block ml-2 py-2 text-sm text-theme-primaryText cursor-pointer"
                role="menuitem"
              >
                Edit cover
              </p>
              <input
                type="file"
                accept="image/*"
                className="absolute inset-0 opacity-0 cursor-pointer"
                onChange={handleCoverUpload}
              />
            </div>
            <div
              className="flex flex-row px-4 items-center"
              onClick={handleRemoveCover}
            >
              <img
                src={Stack}
                alt="edit"
                className="dark:block hidden w-4 h-4"
              />
              <img
                src={StackLight}
                alt="edit"
                className="dark:hidden w-4 h-4"
              />
              <p
                className="block ml-2 py-2 text-sm text-theme-primaryText cursor-pointer"
                role="menuitem"
              >
                Remove cover
              </p>
            </div>
          </div>
        </div>
      )}
      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 sm:px-6">
        {/* logo overlaps the cover; name + member count sit below it, beside it */}
        <div className="-mt-10 flex flex-row items-end gap-4">
          {channel.logo ? (
            <img
              src={channel.logo}
              alt="logo"
              className="rounded-xl object-cover w-20 h-20 flex-shrink-0 ring-4 ring-theme-secondaryBackground bg-theme-secondaryBackground"
              loading="lazy"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = ChannelLogo;
              }}
            />
          ) : (
            <img
              src={ChannelLogo}
              alt="logo"
              className="rounded-xl object-cover w-20 h-20 flex-shrink-0 ring-4 ring-theme-secondaryBackground bg-theme-secondaryBackground"
            />
          )}
          <div className="flex min-w-0 flex-1 flex-col pb-1">
            <p className="truncate text-lg sm:text-xl text-theme-secondaryText font-inter font-[500] leading-tight">
              {channel.name}
            </p>
            <p className="mt-1 text-xs text-theme-emptyEvent font-light">
              {memberCount} {memberCount === 1 ? "member" : "members"}
            </p>
          </div>
        </div>
        {channel.description && (
          <p
            className="mt-3 text-sm font-light text-theme-primaryText"
            style={{ whiteSpace: "pre-line" }}
          >
            {channel.description}
          </p>
        )}
        <div className="flex flex-row flex-wrap gap-3 mt-3">
            {isOwner ? (
              hasInvite ? (
                <div
                  className="py-2 px-3 cursor-pointer text-theme-primaryBackground bg-theme-secondaryText rounded-lg text-sm font-inter"
                  onClick={handleCopyInvite}
                >
                  {inviteCopied ? "Copied!" : "Share Invite"}
                </div>
              ) : null
            ) : isMember ? (
              <div
                className={`border border-theme-primaryText py-2 px-3 rounded-lg cursor-pointer text-theme-secondaryText text-sm font-inter`}
                onClick={() => handleLeaveChannel(channel)}
              >
                Exit channel
              </div>
            ) : (
              <div
                className={`py-2 px-3 cursor-pointer  text-center
                  ${
                    isRequested
                      ? "bg-theme-buttonDisable text-theme-buttonDisableText"
                      : "bg-theme-accent text-theme-accentText hover:bg-theme-accentHover"
                  }
                   rounded-lg text-sm font-inter`}
                onClick={() => handleJoinChannel(channel)}
              >
                {isRequested ? "Requested" : "Join channel"}
              </div>
            )}
            {canManage ? (
              // <div
              //   className="border border-theme-primaryText py-2 px-3 rounded-lg cursor-pointer text-theme-secondaryText text-xs sm:text-sm font-inter"
              //   onClick={handleEditChannel}
              // >
              //   Edit Channel
              // </div>
              <div className="relative flex items-center">
                <img
                  src={Dots}
                  alt="dots"
                  className="dark:block hidden w-6 h-6 mr-2 cursor-pointer"
                  onClick={() => toggleEditDropdown(channel._id)}
                />
                <img
                  src={DotsLight}
                  alt="dots"
                  className="dark:hidden w-6 h-6 mr-2 cursor-pointer"
                  onClick={() => toggleEditDropdown(channel._id)}
                />
                {isEditDropdownOpen === channel._id && (
                  <div
                    ref={dropdownEditRef}
                    className="absolute top-6 left-0 mt-1 ml-3 w-24 rounded-md shadow-lg border  border-theme-chatDivider
                             bg-theme-tertiaryBackground ring-1 ring-black ring-opacity-5 z-50"
                  >
                    <div
                      className="py-1"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="options-menu"
                    >
                      <div className="flex flex-row px-3 items-center">
                        <img
                          src={Edit}
                          alt="edit"
                          className="dark:block hidden w-4 h-4"
                        />
                        <img
                          src={EditLight}
                          alt="edit"
                          className="dark:hidden w-4 h-4"
                        />
                        <p
                          className="block font-light px-2 py-2 text-sm text-theme-secondaryText cursor-pointer"
                          role="menuitem"
                          onClick={handleEditChannel}
                        >
                          Edit
                        </p>
                      </div>
                      {canDeleteChannel && (
                        <div
                          className="flex flex-row px-3 items-center"
                          onClick={(e) => {
                            dispatch(setChannelIdToDelete(channel._id));
                            dispatch(setChannelNameToDelete(channel.name));
                            handleOpenModal("modalDeleteChannelOpen");
                          }}
                        >
                          <img
                            src={Delete}
                            alt="edit"
                            className="dark:block hidden w-4 h-4"
                          />
                          <img
                            src={DeleteLight}
                            alt="edit"
                            className="dark:hidden w-4 h-4"
                          />
                          <p
                            className="block px-2 py-2 font-light text-sm   text-theme-secondaryText cursor-pointer"
                            role="menuitem"
                          >
                            Delete
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ) : hasInvite ? (
              <div
                className={`py-2 px-3 rounded-lg cursor-pointer ${
                  isMember
                    ? "bg-theme-secondaryText text-theme-primaryBackground text-sm"
                    : "border border-theme-primaryText text-theme-secondaryText text-sm font-inter"
                } `}
                onClick={handleCopyInvite}
              >
                {inviteCopied ? "Copied!" : "Share Invite"}
              </div>
            ) : null}
          </div>
      </div>
      <div className="flex flex-col mx-auto w-full max-w-4xl px-4 sm:px-6">
        <div className="border-t my-4 border-t-theme-chatDivider "></div>
        {isLoggedIn && channel.topics.length === 0 && (
          <p className="mt-2 text-xl text-theme-secondaryText font-inter font-normal">
            Topics
          </p>
        )}
        {channel.topics.length === 0 && isOwner && (
          <div className="mt-2 flex flex-row space-x-3">
            <div className="p-4 bg-theme-sidebarBackground rounded-lg flex-col justify-start items-start w-max border border-theme-sidebarDivider">
              <div className="flex-col justify-start items-start  flex">
                <div className=" text-theme-sidebarColor text-xs font-normal font-inter ">
                  Suggested
                </div>
                <div className="text-theme-primaryText text-xs font-normal font-inter mt-1">
                  For open-ended conversations,
                  <br />
                  you can start with General
                </div>
              </div>

              <div
                className="p-2 rounded border cursor-pointer mt-2 w-max border-theme-primaryText text-theme-secondaryText text-xs justify-center items-center "
                onClick={handleCreateTopic}
              >
                Create General
              </div>
            </div>
          </div>
        )}
        {channel.topics.length === 0 && !isOwner && (
          <div className="mt-3 flex flex-col items-center justify-center py-14 text-center">
            <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-theme-tertiaryBackground text-lg text-theme-placeholder">
              #
            </div>
            <p className="text-sm font-medium text-theme-secondaryText">
              No topics yet
            </p>
            <p className="mt-1 text-xs text-theme-emptyEvent">
              There's nothing here yet. Check back soon.
            </p>
          </div>
        )}
        {/* <div className="flex flex-row items-center">
          {isOwner && (
            <div
              className="px-6 py-6 bg-theme-chatDivider rounded-lg flex-col justify-start w-max items-center cursor-pointer"
              onClick={() => handleTopicModal(channel._id)}
            >
              <img src={AddIcon} alt="add" className="mx-auto" />
              <div className="text-center mt-2 text-[#e4e4e4] text-xs font-normal font-inter">
                Add a Topic
              </div>
            </div>
          )}
          {isOwner && (
            <div
              className="px-4 py-6 ml-4 bg-theme-chatDivider rounded-lg flex-col text-center justify-start w-max items-center cursor-pointer"
              onClick={() => handleReorderTopicModal(channel._id)}
            >
              <img src={AddIcon} alt="add" className="mx-auto" />
              <div className="text-center mt-2 text-[#e4e4e4] text-xs font-normal font-inter">
                Reorder Topics
              </div>
            </div>
          )}
        </div> */}
        {(isOwner || isMember) && (
          <div className="items-center text-center mt-3">
            {tabs.map((tab) => {
              if (tab.name === "Members" && !isOwner && !canViewMembers)
                return null;
              return (
                <button
                  key={tab.id}
                  onClick={(event) => handleTabClick(event, tab.href)}
                  className={`mx-2 xs:px-12 px-8 py-3 text-sm transition-colors duration-300 ${
                    activeTab === tab.href
                      ? "border-b-2 text-theme-secondaryText border-theme-secondaryText"
                      : "text-theme-emptyEvent "
                  }`}
                >
                  {tab.name}
                </button>
              );
            })}
          </div>
        )}
        {(isOwner || isMember) && (
          <div
            className={`${
              isOwner || canViewMembers ? "w-80" : "w-28"
            } mx-auto border border-theme-chatDivider`}
            style={{ height: "0.1px" }}
          ></div>
        )}
        {(isOwner || isMember) && (
          <div className="mt-4 mb-6 h-full">
            {activeTab === "topics" ? (
              <TopicsTab channelId={channelId} isOwner={isOwner} />
            ) : (
              <MembersTab channelId={channelId} isOwner={isOwner} />
            )}
          </div>
        )}
        {!isOwner &&
          !isMember &&
          channel.topics?.length > 0 && (
            <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
              <p className="text-sm font-medium text-theme-secondaryText">
                Join to see the conversation
              </p>
              <p className="mt-1 max-w-xs text-xs text-theme-emptyEvent">
                Become a member of {channel.name} to view its topics and join
                the chat.
              </p>
            </div>
          )}
      </div>
    </div>
  );
};

export default ChannelPage;
